import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [5, 1],
        components: [
          [
            {
              variant: "layout",
              data: {
                type: "videoSlider",
                options: {
                  src: `${config.ASSETS_URL}/03/11/principle/car-interior.mov`,
                  startLabel: "25 Hz",
                  endLabel: "800 Hz",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "In this example the sound pressure level is visualized in a car interior. The sound source is a loudspeaker in the front left part of the car. Please notice that the result is depending on the frequency.",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                    },
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
